import { PieChart, Pie, Cell, Tooltip } from "recharts";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{
        background: "#fff",
        padding: "8px",
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        border: "1px solid #ddd",
      }}>
        <p style={{ margin: 0, fontSize: "14px", fontWeight: "bold", color: "#333" }}>
        {payload[0].name === 'Not Eye Contact' ? (
          `No Eye Contact: ${payload[0].value}%`
        ) : (
          `${payload[0].name}: ${payload[0].value}%`
        )}
        </p>
      </div>
    );
  }
  return null;
};

const DonutChart = ({ videoData, colors }) => {
  console.log(videoData.pause_value, "hello");

  const chartData = Object.entries(videoData).map(([key, value]) => {
    // Check if the key is "pause_value" or "speech_value"
    const isSpecialKey = key === "pause_value" || key === "speech_value";

    return {
      name: key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()), // Format the name
      value: isSpecialKey ? value : Math.round(value * 100), // Multiply by 100 only if not a special key
    };
  });

  return (
    <div className="PieChartContainer"  style={{
      outline: "none",
      boxShadow: "none",
      WebkitTapHighlightColor: "transparent", // For mobile touch
    }}
    onMouseDown={(e) => e.preventDefault()} >
    <PieChart width={220} height={250}>
      <Pie
        data={chartData}
        dataKey="value"
        nameKey="name"
        cx="50%"
        cy="50%"
        innerRadius={50} // Creates the donut effect
        outerRadius={100}
        fill="#8884d8"
      >
        {chartData.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
        ))}
      </Pie>
      <Tooltip content={<CustomTooltip />} />
    </PieChart>
    </div>
  );
};

export default DonutChart;